import { lazy } from '@loadable/component';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';

/* Components */
const Login = lazy(() => import('../Components/Login'));
const Dashboard = lazy(() => import('../Components/Dashboard'));
const NotFound = lazy(() => import('../Components/NotFound'));

const Paths = () => (
    <Router future={{ v7_relativeSplatPath: true }}>
      <Routes>
        <Route  path='/' element={<Login />} />
        <Route  path='/dashboard' element={<Dashboard />} />
        <Route  path="*" element={<NotFound />} />
      </Routes>
    </Router> 
);

export default Paths;